import * as Sentry from '@sentry/react';
import { useContext, useEffect } from 'react';
import { SentrySpanContext } from '@/lib/sentry/provider';

export const useSentryBrowserTracing = (location: string) => {
  const pageLoadSpanRef = useContext(SentrySpanContext);
  console.assert(
    pageLoadSpanRef,
    'useSentryBrowserTracing is a no-op if not used in a SentryProvider',
  );

  useEffect(() => {
    if (!pageLoadSpanRef) {
      return;
    }

    const client = Sentry.getClient();

    if (pageLoadSpanRef.current) {
      // Update the pageload span with the route name
      pageLoadSpanRef.current.updateName(location);
      pageLoadSpanRef.current.setAttribute(Sentry.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, 'route');
      console.log('Page load span updated:', pageLoadSpanRef.current);
      pageLoadSpanRef.current = undefined; // Clear after first navigation
    } else if (client) {
      // For subsequent navigations
      Sentry.startBrowserTracingNavigationSpan(client, {
        op: 'navigation',
        name: location,
        attributes: {
          [Sentry.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: 'route',
        },
      });
    } else {
      console.error('Sentry client is not initialized');
    }
  }, [location, pageLoadSpanRef]);
};
